import gql from 'graphql-tag'

/**
 * Query
 */
const ALL_ACTIVE = gql`
    query holidaysActive($date: String) {
        holidaysActive(date: $date) {
            id
            description
            date
            month
            day
            year
            repeat_yearly
            is_active
            status_text
        }
    }
`
const GET_WITH_PAGINATION = gql`
    query holidaysWithPagination ($page: Int, $perPage: Int) {
        holidaysWithPagination (page: $page, first: $perPage) {
            paginatorInfo {
                currentPage
                count
                hasMorePages
                perPage
                total
            }
            data {
                id
                description
                date
                month
                day
                year
                repeat_yearly
                is_active
                status_text
            }
        }
    }
`

const GET_BY_ID = gql`
 mutation holiday ($id: ID!) {
    holiday (id: $id) {
        id
        description
        date
        is_active
        status_text
    }
 }
`
/**
 * Mutations
 */
 const CREATE = gql`
 mutation createHoliday ($input: CreateHolidayInput!) {
    createHoliday (input: $input) {
        id
        description
        date
        is_active
        status_text
     }
 }
`

const UPDATE = gql`
 mutation updateHoliday ($id: ID!, $input: UpdateHolidayInput!) {
    updateHoliday (id: $id, input: $input) {
        id
        description
        date
        is_active
        status_text
     }
 }
`

const CHANGE_STATUS = gql`
 mutation updateHoliday ($id: ID!, $input: UpdateHolidayInput!) {
    updateHoliday (id: $id, input: $input) {
        id
        description
        date
        is_active
        status_text
     }
 }
`

const DELETE = gql`
 mutation deleteHoliday ($id: ID!) {
    deleteHoliday (id: $id) {
        id
        description
        date
        is_active
        status_text
     }
 }
`

export {
    ALL_ACTIVE,
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    CHANGE_STATUS,
    DELETE,
    GET_BY_ID
}
